import { Component } from '@angular/core';
import { HelpContentComponent, HelpService } from '../../../../UI-Lib/Help-Tooltip';
import { TaxAuthorityRateDetails } from '../parcelTaxRateService';
import TaxableAssessmentTypeEnum = Core.TaxableAssessmentTypeEnum;


export interface TaxAuthorityAdjustmentHelpComponentParams {
    taxAuthority: TaxAuthorityRateDetails,
    assessmentComponents: Weissman.Model.Assessments.AssessmentComponent[],
    allowTotalAVOnlyText: boolean,
}

@Component({
    selector: 'tax-authority-adjustment-help',
    templateUrl: './taxAuthorityAdjustmentHelp.component.html',
    standalone: false
})
export class TaxAuthorityAdjustmentHelpComponent implements HelpContentComponent<TaxAuthorityAdjustmentHelpComponentParams> {
    constructor(
        private readonly _helpService: HelpService
    ) {
    }

    params: TaxAuthorityAdjustmentHelpComponentParams;
    exemptions: string[] = [];
    taxAuthority: TaxAuthorityRateDetails;
    availableComponents: Weissman.Model.Assessments.AssessmentComponent[];
    showTotalAVOnlyText: boolean;

    async helpInit(params: TaxAuthorityAdjustmentHelpComponentParams): Promise<void> {
        this.taxAuthority = params.taxAuthority;
        this.availableComponents = params.assessmentComponents;
        this.showTotalAVOnlyText = params.taxAuthority.taxableAssessmentTypeId === TaxableAssessmentTypeEnum.LowerOfTotalAvAndAlternateAv
            && params.allowTotalAVOnlyText
            && !params.taxAuthority.allowExemptionsOnAlternateAV;


        this.populateExemptions();
        this._helpService.refresh();
    }

    private populateExemptions(): void {
        this.exemptions = this.availableComponents
            .filter(x => this.taxAuthority.certainExemptionsTaxAuthorityAssessmentComponentIds.includes(x.assessmentComponentID))
            .map(x => x.componentName);
    }
}
